<script lang="ts">
	import { onMount } from 'svelte';
	import { getAuthorAvatar } from '$lib/user';

	// export let created_by;
	export let avatar_url;
	export let alt = '...';
	// export let view = false;

	let loading = false;
	let src;

	const updateSrc = async () => {
		loading = true;
		src = await getAuthorAvatar(avatar_url);
		// console.log('src', src);
		loading = false;
	};

	onMount(() => {
		// console.log('AuthorAvatar component has loaded');
		updateSrc();
	});
</script>

{#if !loading}
	<img
		style="aspect-ratio: auto;"
		loading="lazy"
		decoding="async"
		class="mt-1 rounded-full object-cover max-w-none w-8 h-8 border-1 border-bloomPurpleNormal"
		width="100%"
		height="auto"
		{src}
		{alt}
	/>
{/if}
